var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";

var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var youTubeIframeAPIReady = false;
function onYouTubeIframeAPIReady() {
  youTubeIframeAPIReady = true;
}

function ThumbnailController(params) {
    if(!params) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
}

ThumbnailController.prototype.setDefaults = function(params) {
    this.player = null;
    this.dom = {
        $parent: $(params.parent).first(),
        $frame: $('div' + params.item),
        $thumbnail: $('img' + params.item),
        $trigger: $('button' + params.trigger)
    }
}

ThumbnailController.prototype.addListeners = function(params) {
    this.dom.$trigger.on('click touchstart', this.load.bind(this));
}

ThumbnailController.prototype.load = function() {
    if(youTubeIframeAPIReady) {
        var instance = this;
        
        new YT.Player(instance.dom.$frame.attr('id'), {
            videoId: instance.dom.$frame.data('video-id'),
            events: {
                'onReady': function(event) {
                    instance.dom.$trigger.remove();
                    instance.dom.$thumbnail.remove();
                    instance.dom.$frame = instance.dom.$parent.find('iframe');
                    instance.dom.$frame.removeAttr('width').removeAttr('height');
                    instance.player = event.target;
                    instance.player.playVideo();
                }
            }
        });
    }
}

new ThumbnailController({
    parent:  '.path-benefits__media',
    item:    '.path-benefits__media-item',
    trigger: '.path-benefits__media-play'
});

new ThumbnailController({
    parent:  '.partner-landing-introduction__media',
    item:    '.partner-landing-introduction__media-item',
    trigger: '.partner-landing-introduction__media-play'
});

new ThumbnailController({
    parent:  '.partner-landing__choose-your-path-media',
    item:    '.partner-landing__choose-your-path-media-item',
    trigger: '.partner-landing__choose-your-path-media-play'
});